import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Dragula from 'react-dragula';

const itemShape = PropTypes.shape({ id: PropTypes.any.isRequired });

class DraggableList extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(itemShape).isRequired,
    disabled: PropTypes.bool,
    containerTag: PropTypes.string,
    containerClass: PropTypes.string,
    itemTag: PropTypes.string,
    itemClass: PropTypes.string,
    children: PropTypes.func.isRequired,
  };

  static defaultProps = {
    disabled: false,
    containerTag: 'div',
    containerClass: '',
    itemTag: 'div',
    itemClass: '',
  };

  constructor(props) {
    super(props);

    this.dragula = null;
    this.dragulaRef = React.createRef();
  }

  componentDidMount() {
    if (!this.props.disabled) this.enableDragula();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.disabled && this.props.disabled) {
      this.disableDragula();
    } else if (prevProps.disabled && !this.props.disabled) {
      this.enableDragula();
    }
  }

  enableDragula = () => {
    const el = this.dragulaRef.current;

    this.dragula = Dragula([el], {}).on('drop', () => {
      const ids = Array.from(el.children).map(c => c.dataset.id);
      this.props.onChange(ids);
    });
  };

  disableDragula = () => {
    if (this.dragula) this.dragula.destroy();
  };

  render() {
    const {
      items,
      disabled,
      containerTag: Container,
      containerClass,
      itemTag: Item,
      itemClass,
      children,
    } = this.props;

    return (
      <Container className={containerClass} ref={this.dragulaRef}>
        {items.map((item, i) => (
          <Item
            key={item.id}
            className={classNames(itemClass, { 'cursor-pointer': !disabled })}
            data-id={item.id}
          >
            {children(item, i)}
          </Item>
        ))}
      </Container>
    );
  }
}

export default DraggableList;
